export const jsQuizz = {
  questions: [
    {
      question: "Roger can’t go out tonight. He ______ a report.",
      choices: ["have to finish", "has finished", "has to finish"],
      type: "V2",
      correctAnswer: "has to finish",
    },
    {
      question: "_________ the new Stephen Spielberg film yet?",
      choices: ["Do you see", "Are you seeing", "Have you seen"],
      type: "V2",
      correctAnswer: "Have you seen",
    },
    {
      question: "Does your sister believe ________ ghosts?",
      choices: ["of", "in", "to"],
      type: "V2",
      correctAnswer: "in",
    },
    {
      question: "Take _________ I can wait.",
      choices: ["the time", "time", "your time"],
      type: "V2",
      correctAnswer: "your time",
    },
    {
      question:
        "This cassette player _________.There’s something wrong with it.",
      choices: ["doesn’t work", "isn’t well", "doesn’t function"],
      type: "V2",
      correctAnswer: "doesn’t work",
    },
    {
      question: "Your car is faster than _________ .",
      choices: ["mine", "my", "my’s"],
      type: "V2",
      correctAnswer: "mine",
    },
    {
      question: "I dont’t know why I __________ silly mistakes!",
      choices: ["always am making", "am always making", "always do"],
      type: "V2",
      correctAnswer: "am always making",
    },
    {
      question: "I am older than you, _________ ?",
      choices: ["dont’t I", "aren’t I", "isnt’t it"],
      type: "V2",
      correctAnswer: "aren’t I",
    },
    {
      question: "Mexico City is ________ than Amsterdam.",
      choices: ["more big", "biggest", "bigger"],
      type: "V2",
      correctAnswer: "bigger",
    },
    {
      question: "I’m very _______ with my new computer.",
      choices: ["glad", "happy", "lucky"],
      type: "V2",
      correctAnswer: "happy",
    },
    {
      question: "You look very tired. You ________ to bed earlier.",
      choices: ["will go", "should go", "have to go"],
      type: "V2",
      correctAnswer: "should go",
    },
    {
      question: "____________ you answer the phone? I’m in the shower!",
      choices: ["Should", "Could", "Do"],
      type: "V2",
      correctAnswer: "Could",
    },
    {
      question: "Could you ________ me five pounds?",
      choices: ["borrow", "lend", "spend"],
      type: "V2",
      correctAnswer: "lend",
    },
    {
      question: "I’m afraid I _________ what to say now.",
      choices: ["am not knowing", "do not know", "know not"],
      type: "V2",
      correctAnswer: "do not know",
    },
    {
      question: "How long ________ English?",
      choices: ["have you been studying", "are you studying", "do you study"],
      type: "V2",
      correctAnswer: "have you been studying",
    },
    {
      question:
        "She lived in New York between 1983 and 1990, so she worked there ______ .",
      choices: ["seven years ago", "for seven years", "it makes seven years"],
      type: "V2",
      correctAnswer: "for seven years",
    },
    {
      question: "I don’t want _________ to drink, thanks.",
      choices: ["anything", "something", "nothing"],
      type: "V2",
      correctAnswer: "anything",
    },
    {
      question: "_________ the traffic be very heavy at 6 p.m.?",
      choices: ["Isn’t", "Don’t", "Won’t"],
      type: "V2",
      correctAnswer: "Won’t",
    },
    {
      question:
        "Kate doesn’t know when the meeting is. Her boss didn’t tell _______ .",
      choices: ["her", "him", "she"],
      type: "V2",
      correctAnswer: "her",
    },
    {
      question: "I ____________ to bed now. Good night!",
      choices: ["am going", "go", "goes"],
      type: "V2",
      correctAnswer: "am going",
    },
    {
      question: "This chair is _________ chair in the office.",
      choices: ["more comfortable", "most comfortable", "the most comfortable"],
      type: "V2",
      correctAnswer: "the most comfortable",
    },
    {
      question: "He speaks Japanese very ________.",
      choices: ["good", "better", "well"],
      type: "V2",
      correctAnswer: "well",
    },
    {
      question: "Last year I ________ a long journey to China.",
      choices: ["took", "went on", "made"],
      type: "V2",
      correctAnswer: "took",
    },
    {
      question: "Have you ever ______ a Ferrari?",
      choices: ["driven", "drive", "drove"],
      type: "V2",
      correctAnswer: "driven",
    },
    {
      question: "When the mother opened the door, the baby _________ .",
      choices: ["slept", "was sleeping", "has slept"],
      type: "V2",
      correctAnswer: "was sleeping",
    },
    {
      question: "What time ____________ back home?",
      choices: [
        "comes your brother",
        "your brother is coming",
        "does your brother come",
      ],
      type: "V2",
      correctAnswer: "does your brother come",
    },
    {
      question: "She’s Swedish, _____________ .",
      choices: ["wasn’t she?", "hasn’t she?", "isn’t she?"],
      type: "V2",
      correctAnswer: "isn’t she?",
    },
    {
      question: "You work too much. Why don’t you________a holiday?",
      choices: ["take", "have", "make"],
      type: "V2",
      correctAnswer: "take",
    },
    {
      question: "What did she _________ about the meeting?",
      choices: ["talk", "say", "tell"],
      type: "V2",
      correctAnswer: "say",
    },
    {
      question:
        "It was a very good party. Everyone _________ a wonderful time.",
      choices: ["had", "took", "made"],
      type: "V2",
      correctAnswer: "had",
    },
  ],
};

export const resultInitalState = {
  score: 0,
  correctAnswers: 0,
};
